import React from "react";
import clsx from "classnames";
import { ReactComponent as Right } from "../../svgs/right.svg";
import { routes } from "../../helper/misc";
import { useLocation } from "react-router-dom";

const steps = [
  {
    text: "Buy water credit",
    routes: [routes.buy_water, routes.pay, "receipt"],
  },
  // { text: "Select preferred payment method", route: routes.buy_water },
  { text: "Pay", routes: ["receipt", routes.pay] },
  { text: "Receipt", routes: ["receipt"] },
];

const BuyWaterSteps = () => {
  const { pathname } = useLocation();
  const altPathname = pathname.includes("receipt") ? "receipt" : pathname;
  return (
    <div className="flex justify-between items-center space-x-5">
      {steps.map((step, index) => (
        <div className="flex items-center space-x-[6px]" key={index}>
          <div
            className={clsx(
              "h-[18px] w-[18px] bg-[#A6A6A6] rounded-full flex items-center justify-center",
              { "!bg-pw-blue": step.routes.includes(altPathname) }
            )}
          >
            <Right
              className={clsx("stroke-white/[.8]", {
                "!stroke-white": step.routes.includes(pathname),
              })}
            />
          </div>
          <span className={clsx("font-medium text-[17px] text-[#A6A6A6]")}>
            {step.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default BuyWaterSteps;
